module.exports = __webpack_public_path__ + "static/media/notfound.92213dd6.svg";